function updatePagination({ currentPage, totalPages }, resultData) {
  const paginationContainer = document.querySelector(".pagination__nav");
  const paginationContainerBoa = document.querySelector(".boa-pagination");
  if (resultData.length === 0) {
    paginationContainer.innerHTML = "";
  }
  const currentPageNumber = Number(currentPage);
  if (!paginationContainer || totalPages <= 0) return;
  paginationContainer.classList.remove("hidden");
  paginationContainer.innerHTML = "";

  const createPageLink = (page) => {
    const isActive = currentPageNumber === page;
    const disabledAttrs = isActive ? 'aria-disabled="true" tabindex="-1"' : "";
    return `<a data-page="${page}" href="?page=${page}" class="pagination__nav-item ${
      isActive ? "active active-pagination-item" : ""
    }" ${disabledAttrs}>${page}</a>`;
  };

  let paginationHtml = "";

  // Previous button
  if (currentPageNumber > 1) {
    paginationHtml += `<a class="pagination__nav-item" rel="prev" data-page="${
      currentPageNumber - 1
    }" href="?page=${currentPageNumber - 1}">→</a>`;
  }

  // First Page
  paginationHtml += createPageLink(1);

  // Middle Pages Logic with Dots
  if (totalPages > 4) {
    if (currentPageNumber > 3)
      paginationHtml += `<span class="pagination__nav-item">...</span>`;

    const start = Math.max(2, currentPageNumber - 1);
    const end = Math.min(totalPages - 1, currentPageNumber + 1);

    for (let i = start; i <= end; i++) {
      paginationHtml += createPageLink(i);
    }

    if (currentPageNumber < totalPages - 2)
      paginationHtml += `<span class="pagination__nav-item">...</span>`;
  } else {
    for (let i = 2; i < totalPages; i++) {
      paginationHtml += createPageLink(i);
    }
  }

  // Last Page
  if (totalPages > 1) {
    paginationHtml += createPageLink(totalPages);
  }

  // Next button
  if (currentPageNumber < totalPages) {
    paginationHtml += `<a class="pagination__nav-item" rel="next" data-page="${
      currentPageNumber + 1
    }" href="?page=${currentPageNumber + 1}">←</a>`;
  }

  if (paginationContainerBoa) {
    paginationContainerBoa.classList.remove("boa-hidden");
  }
  // Update the pagination container with the new pagination HTML
  paginationContainer.innerHTML = paginationHtml;

  // Add click handlers for AJAX pagination
  paginationContainer.querySelectorAll('a[data-page]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const page = parseInt(link.dataset.page);
      const url = new URL(window.location.href);
      const searchQuery = url.searchParams.get('q');
      const filters = {
        catalog: url.searchParams.get('catalog') || null,
        sortBy: url.searchParams.get('sortBy') || null,
        inStock: url.searchParams.get('inStock') === 'true' || null,
      };

      const collectionElements = document.querySelector('.boa-collection-banner-container');
      if (collectionElements) {
        const { collectionId } = collectionElements.dataset;
        fetchCollectionSearchResults(collectionId, page, searchQuery, filters);
      } else {
        fetchSearchResults(page, searchQuery, filters);
      }

      // Update URL with page param
      url.searchParams.set('page', page);
      window.history.replaceState({}, '', url.toString());
    });
  });
};

function updateCollectionGrid(products) {
  const collectionGrid = document.querySelector(".product-list__inner");
  if (!collectionGrid) {
    return;
  }
  
  // Reset loading state
  collectionGrid.style.opacity = '';
  collectionGrid.style.pointerEvents = '';
  const loadingStates = document.querySelectorAll('.main-search__loading-state');
  loadingStates.forEach(loadingState => {
    loadingState.style.display = 'none';
  });
  if (collectionGrid && !collectionGrid.closest('.shopify-section--main-search')) {
    // Add the class to the parent container if not present
    const parent = collectionGrid.parentElement;
    if (parent) {
      parent.classList.add('shopify-section--main-search');
    }
  }
  if (products.length === 0) {
    collectionGrid.innerHTML = " לא נמצאו תוצאות ";
    return;
  }
  // Main loop to create and insert product items
  collectionGrid.innerHTML = ""; // Clear the existing grid
  collectionGrid.classList.remove("boa-hidden");

  products.forEach((product) => {
    const variant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
    const productUrl = `/products/${product.handle}`;
    const imageUrl = product.image || "https://via.placeholder.com/400";
    const available = product.isAvailable !== undefined ? product.isAvailable : (variant ? variant.available : true);

    // Create product-item element
    const productItem = document.createElement("product-item");
    productItem.classList.add(
      "product-item",
      "product-hidden",
      "collection-inner-search-product-item"
    );

    // Create the image wrapper and image
    const imageWrapper = document.createElement("div");
    imageWrapper.classList.add("product-item__image-wrapper");

    // Missing SVG overlay for unavailable products
    if (!available) {
      const missingOverlay = document.createElement("div");
      missingOverlay.className = "product-item__missing-overlay";
      const img = document.createElement("img");
      // Get asset URL from script tag data attribute
      const missingSvgElement = document.querySelector('.missing-book-svg[data-missing-svg-url]');
      img.src = missingSvgElement?.dataset.missingSvgUrl;
      img.alt = "Missing";
      img.className = "product-item__missing-overlay-img";
      missingOverlay.appendChild(img);
      imageWrapper.appendChild(missingOverlay);
    }

    const imageLink = document.createElement("a");
    imageLink.href = productUrl;
    imageLink.setAttribute("data-instant", "");
    imageLink.classList.add(
      "product-item__aspect-ratio",
      "aspect-ratio",
      "aspect-ratio--short"
    );
    imageLink.style.paddingBottom = "100.0%";
    imageLink.style.setProperty("--aspect-ratio", "1.0");

    const image = document.createElement("img");
    image.src = imageUrl;
    image.alt = product.title;
    image.width = 400;
    image.height = 400;
    image.loading = "eager";
    image.classList.add("product-item__primary-image");

    imageLink.appendChild(image);
    imageWrapper.appendChild(imageLink);

    // Info block
    const info = document.createElement("div");
    info.classList.add("product-item__info");
    const productMeta = document.createElement("div");
    productMeta.classList.add("product-item-meta");

    // Title
    const titleLink = document.createElement("a");
    titleLink.href = productUrl;
    titleLink.classList.add("product-item-meta__title");
    titleLink.textContent = product.title.replace(' /', ':');
    productMeta.appendChild(titleLink);

    
    // Publishing info
    const authorAndPublishingWrap = document.createElement("div");
    authorAndPublishingWrap.classList.add("author-and-publishing-wrap");
    const publishing = product.publishing || '';
    const yearPublishing = product.yearPublication || '';
    
    // Author (as link)
    if (product.author) {
      const authorLink = document.createElement("a");
      authorLink.href = `/search?q=${encodeURIComponent(product.author)}`;
      authorLink.classList.add("author");
      authorLink.textContent = product.author;
      authorAndPublishingWrap.appendChild(authorLink);
    }

    if (publishing || yearPublishing) {
      const publishingSpan = document.createElement("span");
      publishingSpan.textContent = publishing + (publishing && yearPublishing ? ', ' : '') + yearPublishing;
      authorAndPublishingWrap.appendChild(publishingSpan);
    }

    if (authorAndPublishingWrap.childNodes.length > 0) {
      productMeta.appendChild(authorAndPublishingWrap);
    }
    

    // Collections info
    if (product?.collections?.length > 0) {
      const collectionsWrap = document.createElement("div");
      collectionsWrap.classList.add("collections-wrap");
      
      // Display max 2 collections
      const collectionsToShow = product.collections.slice(0, 2);
      collectionsToShow.forEach((collection, index) => {
        const collectionLink = document.createElement("a");
        collectionLink.href = collection.link;
        collectionLink.classList.add("collection-link");
        collectionLink.textContent = collection.name;
        
        collectionsWrap.appendChild(collectionLink);
        
        // Add separator between collections (except for the last one)
        if (index < collectionsToShow.length - 1) {
          const separator = document.createElement("span");
          separator.textContent = ", ";
          separator.classList.add("collection-separator");
          collectionsWrap.appendChild(separator);
        }
      });
      
      productMeta.appendChild(collectionsWrap);
    }

    // Price container - moved to bottom
    const priceContainer = document.createElement("div");
    priceContainer.classList.add("product-item-meta__price-list-container");
    const priceList = document.createElement("div");
    priceList.classList.add("price-list");
    // Price - filter by available variants only
    const availableVariants = product.variants?.filter(v => v.available) || [];
    const sortedAvailable = [...availableVariants].sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
    const lowestAvailable = sortedAvailable[0];
    const highestAvailable = sortedAvailable[sortedAvailable.length - 1];

    let price = highestAvailable?.price || (variant && variant.price ? variant.price : (product.price || ""));
    let compareAtPrice = lowestAvailable?.compareAtPrice || (variant && variant.compareAtPrice ? variant.compareAtPrice : (product.compareAtPrice || ""));
    let lowestVariantPrice = lowestAvailable?.price || "";
    const formatPrice = (priceValue) => {
      if (!priceValue || priceValue === "0" || priceValue === 0) return priceValue;
      const priceStr = priceValue.toString();
      if (priceStr.indexOf('.') === -1) {
        return priceStr + '.00';
      }
      return priceStr;
    };
    if (!available) {
      const productData = JSON.stringify({
        id: product.id,
        title: product.title,
        handle: product.handle,
        tags: [],
        available: false,
        author: product.author || product.type || null,
        publisher: product.publishing || product.vendor || null,
        image: product.image || null,
        yearPublication: product.yearPublication || null,
        variants: [
          {
            id: variant.id,
            title: product.title,
            available: false,
            inventory_quantity: 0,
            inventory_management: "shopify"
          }
        ]
      });

      const backToStockButton = document.createElement("a");
      backToStockButton.href = '#';
      backToStockButton.classList.add("button-out-of-stock");
      const text = document.createElement("span");
      text.textContent = "צודו לי";
      backToStockButton.appendChild(text);
      const icon = document.createElement("span");
      icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" focusable="false" width="26" height="26" viewBox="0 0 58.2 58.2">
        <polygon points="7.7 27.4 8.14 29.91 14.35 35.31 17.08 33.79 12.3 28.92 16.72 23.43 14.62 21.91 7.7 27.4"/>
        <path d="M33.32,46.32c-2.12-3.21-5.98-9.47-5.98-17.34,0-7.75,3.09-13.89,5.98-17.46l2.73,1.04c-2.29,2.65-5.54,8.87-5.54,16.22,0,7.27,3.89,13.97,5.54,16.54l-2.73,1Z"/>
        <path d="M21.98,30.22c-2.91.17-6.17.41-9.02.59l-2.3-4.43,11.38.69,3.51.04,22.58-.66,1.94,4.4-24.57-.66-3.51.03Z"/>
      </svg>`;
      backToStockButton.appendChild(icon);
      priceList.appendChild(backToStockButton);

      [backToStockButton, text, icon].forEach(element => {
        element.classList.add("BIS_trigger");
        element.setAttribute('data-product-data', productData);
      });
    }
    else if (!price || price === "0" || price === 0) {
      const priceSpan = document.createElement("span");
      priceSpan.classList.add("price", "price--large");
      priceSpan.textContent = 'לא זמין';
      priceList.appendChild(priceSpan);
    } else if (lowestVariantPrice && lowestVariantPrice !== price && lowestVariantPrice !== "0" && lowestVariantPrice !== 0) {
      // Display price range when lowestVariantPrice exists and is different from current price
      const priceSpan = document.createElement("span");
      priceSpan.classList.add("price", "price--highlight", "price--large");
      priceSpan.textContent = formatPrice(lowestVariantPrice) + ' ₪ - ' + formatPrice(price) + ' ₪';
      priceList.appendChild(priceSpan);
    } else if (compareAtPrice && price < compareAtPrice) {
      const priceSpan = document.createElement("span");
      priceSpan.classList.add("price", "price--highlight", "price--large", "discount");
      priceSpan.textContent = formatPrice(price) + ' ₪';
      const compareAtPriceElement = document.createElement("span");
      compareAtPriceElement.classList.add("price", "price--compare");
      compareAtPriceElement.textContent = formatPrice(compareAtPrice) + ' ₪';
      priceList.appendChild(priceSpan);
      priceList.appendChild(compareAtPriceElement);
    } else {
      const priceSpan = document.createElement("span");
      priceSpan.classList.add("price", "price--highlight", "price--large");
      priceSpan.textContent = formatPrice(price) + ' ₪';
      priceList.appendChild(priceSpan);
    }
    priceContainer.appendChild(priceList);
    productMeta.appendChild(priceContainer);

    info.appendChild(productMeta);

    // --- Begin merged quick-add logic ---
    // Function to create the quick buy form/button (from quick-add branch)
    function createQuickBuyForm(variant, available) {
      // Only create quick buy form for available products
      if (!available) {
        return null;
      }

      const form = document.createElement("form");
      form.method = "post";
      form.action = "/cart/add";
      form.classList.add("product-item__quick-form");
      form.enctype = "multipart/form-data";
      form.setAttribute("is", "product-form");
      // Hidden input for variant ID
      const inputId = document.createElement("input");
      inputId.type = "hidden";
      inputId.name = "id";
      inputId.value = variant ? variant.id : "";
      // Hidden input for quantity
      const inputQuantity = document.createElement("input");
      inputQuantity.type = "hidden";
      inputQuantity.name = "quantity";
      inputQuantity.value = "1";

      // Create the quick buy button (circular with icon)
      const button = document.createElement("button");
      button.type = "submit";
      button.classList.add("product-item__quick-buy-button");

      // Add visually hidden text for accessibility
      const buttonText = document.createElement("span");
      buttonText.classList.add("visually-hidden");
      buttonText.textContent = "Add to Cart";
      button.appendChild(buttonText);

      // Add the new SVG icon using createElementNS (same method as before)
      const svgNS = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(svgNS, "svg");
      svg.setAttribute("width", "800px");
      svg.setAttribute("height", "800px");
      svg.setAttribute("viewBox", "0 0 32 32");
      svg.setAttribute("version", "1.1");
      svg.setAttribute("xmlns", svgNS);
      svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
      svg.setAttribute("xmlns:sketch", "http://www.bohemiancoding.com/sketch/ns");

      // <g id="Page-1" ...>
      const gPage1 = document.createElementNS(svgNS, "g");
      gPage1.setAttribute("id", "Page-1");
      gPage1.setAttribute("stroke", "none");
      gPage1.setAttribute("stroke-width", "1");
      gPage1.setAttribute("fill", "none");
      gPage1.setAttribute("fill-rule", "evenodd");
      gPage1.setAttribute("sketch:type", "MSPage");

      // <g id="Icon-Set-Filled" ...>
      const gIconSet = document.createElementNS(svgNS, "g");
      gIconSet.setAttribute("id", "Icon-Set-Filled");
      gIconSet.setAttribute("sketch:type", "MSLayerGroup");
      gIconSet.setAttribute("transform", "translate(-466.000000, -1089.000000)");

      // <circle cx="482" cy="1105" r="16" fill="#f7dc6b"/>
      const circle = document.createElementNS(svgNS, "circle");
      circle.setAttribute("cx", "482");
      circle.setAttribute("cy", "1105");
      circle.setAttribute("r", "16");
      circle.setAttribute("fill", "#f7dc6b");
      gIconSet.appendChild(circle);

      // <g fill="#231f20"> ... </g>
      const gPlus = document.createElementNS(svgNS, "g");
      gPlus.setAttribute("fill", "#231f20");

      // Horizontal bar
      const rectH = document.createElementNS(svgNS, "rect");
      rectH.setAttribute("x", "476");
      rectH.setAttribute("y", "1104");
      rectH.setAttribute("width", "12");
      rectH.setAttribute("height", "2");
      rectH.setAttribute("rx", "1");
      gPlus.appendChild(rectH);

      // Vertical bar
      const rectV = document.createElementNS(svgNS, "rect");
      rectV.setAttribute("x", "481");
      rectV.setAttribute("y", "1099");
      rectV.setAttribute("width", "2");
      rectV.setAttribute("height", "12");
      rectV.setAttribute("rx", "1");
      gPlus.appendChild(rectV);

      gIconSet.appendChild(gPlus);
      gPage1.appendChild(gIconSet);
      svg.appendChild(gPage1);
      button.appendChild(svg);

      form.appendChild(inputId);
      form.appendChild(inputQuantity);
      form.appendChild(button);

      // Add custom form submission handler to mimic ProductForm behavior
      form.addEventListener("submit", async function(event) {
        event.preventDefault();
        
        if (!this.checkValidity()) {
          this.reportValidity();
          return;
        }

        const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
        submitButtons.forEach((submitButton) => {
          submitButton.setAttribute("disabled", "disabled");
          submitButton.setAttribute("aria-busy", "true");
        });

        const productForm = new FormData(this);
        productForm.append("sections", ["mini-cart"]);
        productForm.delete("option1");
        productForm.delete("option2");
        productForm.delete("option3");

        try {
          const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
            body: productForm,
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest"
            }
          });

          submitButtons.forEach((submitButton) => {
            submitButton.removeAttribute("disabled");
            submitButton.removeAttribute("aria-busy");
          });

          const responseJson = await response.json();

          if (response.ok) {
            // Check cart type setting and behave accordingly
            if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
              return window.location.href = `${window.Shopify.routes.root}cart`;
            }

            // Dispatch variant:added event
            this.dispatchEvent(new CustomEvent("variant:added", {
              bubbles: true,
              detail: {
                variant: Object.prototype.hasOwnProperty.call(responseJson, "items") ? responseJson["items"][0] : responseJson
              }
            }));

            // Fetch updated cart and dispatch events
            fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
              const cartContent = await response2.json();
              document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                bubbles: true,
                detail: {
                  cart: cartContent
                }
              }));
              cartContent["sections"] = responseJson["sections"];
              document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  cart: cartContent,
                  openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
                }
              }));
            });
          }

          // Dispatch cart notification event
          this.dispatchEvent(new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: {
              status: response.ok ? "success" : "error",
              error: responseJson["description"] || ""
            }
          }));

        } catch {
          submitButtons.forEach((submitButton) => {
            submitButton.removeAttribute("disabled");
            submitButton.removeAttribute("aria-busy");
          });

          // Dispatch error notification
          this.dispatchEvent(new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: {
              status: "error",
              error: "Network error occurred"
            }
          }));
        }
      });

      return form;
    }
    // --- End merged quick-add logic ---

    // Add quick buy form if available
    const quickBuyForm = createQuickBuyForm(variant, available);
    if (quickBuyForm) {
      imageWrapper.appendChild(quickBuyForm);
    }

    // Append everything to the productItem
    productItem.appendChild(imageWrapper);
    productItem.appendChild(info);

    // Finally, insert the productItem into the collection grid
    collectionGrid.appendChild(productItem);
    setTimeout(() => {
      productItem.classList.remove("product-hidden");
    }, 500);
    const collectionContainer = document.getElementById("facet-main");
    collectionContainer.removeAttribute("hidden");
  });
};

const resetSearch = (searchTerm) => {
  const url = new URL(window.location);
  if (!searchTerm) {
    url.searchParams.delete("q");
    url.searchParams.delete("page");
    window.location.href = url;
  } else {
    url.searchParams.set("q", searchTerm);
    url.searchParams.set("page", "1"); // Reset page to 1 on new search
  }
  url.searchParams.delete("page");
  window.history.replaceState({}, "", url.toString());
};